/*
 * @Author: jixiaoyong
 * @Email: jixiaoyong1995@gmail.com
 * @Webiste: https://jixiaoyong.github.io
 * @Date: 24/05/29
 * @LastEditors: jixiaoyong
 * @LastEditTime: 24/05/29
 * @FilePath: /app_list/src/router/routers.js
 * @Description:
 *
 * Copyright (c) 2024 by jixiaoyong, All Rights Reserved.
 */
import EditorPage from "@/components/EditorPage.vue";
import { createRouter, createWebHistory } from "vue-router";
import HomePage from "./../components/HomePage.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/editor",
    name: "editor",
    component: EditorPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
